import { cachePolicies } from "./cachePolicies";
import { middlewares } from "./middlewares";

export const configs = {
  cachePolicies,
  linkMiddlewares: middlewares,
};
